module.exports = __webpack_public_path__ + "static/media/SWSCRC1-09.82d3cb61.mp3";